import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT } from './authActionTypes'

const initialState = {
  token: localStorage.getItem('auth_token') || null,
  loading: false,
  error: null,
  isAuthenticated: !!localStorage.getItem('auth_token')
}

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        token: action.payload.key,
        isAuthenticated: true,
        error: null
      }
    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        token: null,
        isAuthenticated: false,
        error: action.error
      }
    case LOGOUT:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        error: null
      }
    default:
      return state
  }
}
